import React from 'react';
import { Redirect } from 'react-router-dom';
import { useLocation } from 'react-router';

const ActivePageBasedRedirect = () => {
  const { pathname } = useLocation();

  // Default authenticated landing page
  if (pathname === '/') {
    return <Redirect to='/portal/dashboard' />;
  }

  // Let the next fallback route handle unknown paths (e.g., /error/404)
  if (!pathname) {
    return null;
  }

  return null;

};

export default ActivePageBasedRedirect;
